import * as React from 'react';

import { SupplierListDataService } from 'src/app/products/suppliers/list/supplier-list.data';
import { SupplierEditorView } from './supplier-editor.view';

interface SupplierEditorControllerProps {
	value: number | number[] | null;
	mode: ControlMode;
	onChange: (supplier: SupplierSummary | SupplierSummary[]) => void;
	setBusy(isBusy: boolean);
	label?: string;
	supplierType?: number;
	productId?: number;
	required?: boolean;
	multi?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
	afterLoad?: (supplier?: SupplierSummary) => void;
}

export class SupplierEditorController extends React.Component<SupplierEditorControllerProps, {}> {
	static defaultProps = {
		multi: false
	};

	supplierDataService: SupplierListDataService;

	constructor(props: Readonly<SupplierEditorControllerProps>) {
		super(props);

		this.supplierDataService = SupplierListDataService.make();
	}

	public componentWillReceiveProps(nextProps: Readonly<SupplierEditorControllerProps>){
		if(nextProps.productId != this.props.productId || nextProps.supplierType != this.props.supplierType){
			this.supplierQuery(this.supplierDataService.searchKeywords, nextProps);
		}
	}

	supplierQuery = (q?: string, props: Readonly<SupplierEditorControllerProps> = this.props): Promise<QueryResult<SupplierSummary>> => {
		return new Promise<QueryResult<SupplierSummary>>((resolve, reject) => {
			props.setBusy(true);

			this.supplierDataService.addFilter('isDeleted', 'eq', false);
			if (props.supplierType != null) {
				this.supplierDataService.addFilter('type', 'eq', props.supplierType);
			} else if (props.supplierType == null) {
				this.supplierDataService.removeFilter('type');
			}
			if (props.productId) {
				this.supplierDataService.params = { productId: props.productId };
			}
			this.supplierDataService.addSorting('id', 'asc', true);
			this.supplierDataService.searchKeywords = q;

			this.supplierDataService
				.load(query => query)
				.then((items) => {
					props.setBusy(false);
					resolve({
						items: items,
						totalCount: this.supplierDataService.count
					});
				});
		});
	};

	render(): JSX.Element {
		return (
			<SupplierEditorView
				onGetErrorMessage={this.props.onGetErrorMessage}
				supplierRequest={{ query: this.supplierQuery, dataSet: this.supplierDataService }}
				onChange={this.props.onChange}
				value={this.props.value}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
				multi={this.props.multi}
				supplierType={this.props.supplierType}
				afterLoad={this.props.afterLoad}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/parts/supplier-editor.controller.tsx